/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Weighing_Approve_ErrorInputs */

const vi_toast_weighing_approve_error = /** @type {(inputs: Toast_Weighing_Approve_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt phiếu cân thất bại`)
};

/**

* @param {Toast_Weighing_Approve_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_weighing_approve_error = /** @type {((inputs?: Toast_Weighing_Approve_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Weighing_Approve_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_weighing_approve_error(inputs)
});